/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    app: {
      viewTitle: '',
      bodyClientRect: null
    },
    products: {
      // TODO:28.10.2022:yehor.pytomets:ls-spine-model: Remove when replaced with real products.
      list: [],
    },
    evaluations: {
      // TODO:28.10.2022:yehor.pytomets:ls-spine-model: Remove when replaced with real evaluations.
      active: [],
      expired: []
    },
    licenses: {
      // TODO:28.10.2022:yehor.pytomets:ls-spine-model: Remove when replaced with real licenses.
      nonCommercialRequests: [],
      nonCommercial: [],
      demo: []
    },
    selectionMenus: {

      // Due to the specifics of how popups of selection menu components are positioned in the DOM
      // (they are placed inside of v-app to ensure correct display on top of other content),
      // they do not inherit custom CSS properties declared on the level of the component, thus
      // it is required to set the respective CSS variable(s) on the level of application.
      horizOffset: '0px'
    }
  },
  mutations: {
    setViewTitle(state, payload) {
      state.app.viewTitle = payload.title;
    },

    setBodyClientRect(state, payload) {
      state.app.bodyClientRect = payload.bodyClientRect;
    },

    setSelectionMenusHorizOffset(state, payload) {
      state.selectionMenus.horizOffset = payload.horizOffset;
    }
  },
  actions: {
  },
  modules: {
  }
});
